var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2202_16861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2609 33.8369C57.7626 19.0583 48.6209 4.23915 33.8422 0.737457C19.0636 -2.76424 4.24442 6.37753 0.742723 21.1562C-2.75897 35.9348 6.3828 50.754 21.1614 54.2557C35.9401 57.7574 50.7592 48.6156 54.2609 33.8369Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0488 36.027H14.9506C14.2071 36.027 13.6035 35.4233 13.6035 34.6799C13.6035 33.9365 14.2071 33.3329 14.9506 33.3329H40.0488C40.7922 33.3329 41.3958 33.9365 41.3958 34.6799C41.3958 35.4233 40.7922 36.027 40.0488 36.027Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8857 22.8171C41.8857 24.4183 40.5894 25.7209 38.9819 25.7209C37.3743 25.7209 36.0781 24.4183 36.0781 22.8171C36.0781 21.2159 37.3807 19.9133 38.9819 19.9133C40.5831 19.9133 41.8857 21.2159 41.8857 22.8171Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9159 22.8171C18.9159 24.4183 17.6134 25.7209 16.0122 25.7209C14.411 25.7209 13.1084 24.4183 13.1084 22.8171C13.1084 21.2159 14.411 19.9133 16.0122 19.9133C17.6134 19.9133 18.9159 21.2159 18.9159 22.8171Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2202_16861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralOn);
export default __webpack_public_path__ + "static/media/neutral_on.f4290d873f4fd9f1ea85b0faaf447597.svg";
export { ForwardRef as ReactComponent };